import {Component, Input, OnInit} from '@angular/core';
import {MarketingItemModel} from '../../models/marketing-item.model';

@Component({
  selector: 'app-marketing-item',
  templateUrl: './marketing-item.component.html',
  styleUrls: ['./marketing-item.component.scss']
})
export class MarketingItemComponent implements OnInit {

  @Input() marketingItem: MarketingItemModel;
  @Input() classes?: string;

  constructor() {
  }

  ngOnInit() {
  }

}
